"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const sidebar_item_1 = require("./sidebar-item");
const re_resizable_1 = require("re-resizable");
exports.Sidebar = ({ isVisible, subItems, children }) => (react_1.default.createElement(re_resizable_1.Resizable, { className: classnames_1.default("sidebar", { "sidebar-visible": isVisible }), defaultSize: { width: 200, height: "100vh" } },
    react_1.default.createElement("nav", null,
        react_1.default.createElement("ul", { className: "sidebar-item-group sidebar-item-group-expanded" },
            subItems && sidebar_item_1.getSidebarItemsFromData(subItems, true, 0),
            children))));
//# sourceMappingURL=sidebar.js.map